import React from 'react'
import { Box, Typography } from '@mui/material'
import { IconX } from '@tabler/icons-react'
import useAppUtilities from '../../../../hooks/useAppUtilities'
import { setIsInfluencerOnboardModalOpen } from '../../../../store/influencer/contentCreator'

interface OnboardHeaderProps {
  title: string
}

const OnboardHeader: React.FC<OnboardHeaderProps> = ({ title }) => {
  const { dispatch } = useAppUtilities()
  const onClose = (): void => {
    dispatch(setIsInfluencerOnboardModalOpen(false))
  }
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={2}
    >
      <Typography variant="body1">{title}</Typography>
      {onClose && (
        <IconX
          size={20}
          stroke={2}
          style={{ cursor: 'pointer' }}
          onClick={onClose}
        />
      )}
    </Box>
  )
}

export default OnboardHeader
